import promotionCodesRepository from '@/repositories/PromotionCodesRepository'
import { FLAT_RATE_WRITTEN_CONSULTATION } from '@/constants/db/subscriptionTypes'
import { CHANGE_PAYMENT_METHOD, FLAT_RATE } from '@/constants/paymentTypes'
import i18nMixin from '@/mixins/i18n.mixin'
import { getCurrencyByDomain } from '@/constants/currencies'

const I18N_FILE = 'payments'
const PERCENT_SYMBOL = '%'

export default {
    data () {
        return {
            promotionCode: null,
            showPromotionCodeQuestion: true,
            discountApplied: null,
            isFixedPriceDiscount: null,
            termsAccepted: false,
            showEPrescriptionAvailableDialog: false,
            cvvInputType: 'text',
            creditCardData: {
                holderName: null,
                cardNumber: null,
                sanitizedCardNumber: null,
                month: null,
                year: null,
                cvv: null
            },
            CHANGE_PAYMENT_METHOD
        }
    },
    mixins: [i18nMixin(I18N_FILE)],
    computed: {
        promotionCodeData () {
            return {
                code: this.promotionCode,
                appointmentId: this.appointmentId,
                profId: this.profIdForWrittenFlatRate,
                servicesPackagesId: this.servicesPackageId,
                subscriptionType: this.paymentType === FLAT_RATE ? FLAT_RATE_WRITTEN_CONSULTATION : null
            }
        },
        discountSymbol () {
            return this.isFixedPriceDiscount ? this.currency : PERCENT_SYMBOL
        },
        freeService () {
            return this.isFixedPriceDiscount ? this.discountApplied >= this.price : this.discountApplied === 100
        },
        currency () {
            return getCurrencyByDomain()
        },
        months () {
            let months = []
            for (let i = 1; i <= 12; i++) {
                let value = i.toString().padStart(2, '0')
                months.push({ text: value, value: value })
            }
            return months
        },
        years () {
            let years = []
            let currentYear = parseInt(new Date().getFullYear().toString())
            for (let i = currentYear; i <= currentYear + 20; i++) {
                years.push({ text: i.toString(), value: i.toString().substring(2) })
            }
            return years
        },
        showPriceBlock () {
            return this.paymentType !== CHANGE_PAYMENT_METHOD
        },
        finalPrice () {
            if (this.discountApplied) {
                let price = this.isFixedPriceDiscount ? this.price - this.discountApplied : this.price - (this.price * (this.discountApplied / 100))
                return parseFloat(price).toFixed(2)
            } else {
                return this.price
            }
        },
        finalPriceText () {
            return this.finalPrice > 0 ? `${this.finalPrice} ${this.currency}` : this.$t('payments.free')
        }
    },
    methods: {
        closeModalAndReload () {
            if (this.servicesPackageId) {
                this.$store.dispatch('showSuccessAlert', this.$t('successHireServicesPackage'))
                this.goRoot()
            } else if (this.profIdForWrittenFlatRate) {
                this.$store.dispatch('showSuccessAlert', this.$t('successHireFlatRate'))
                this.goRoot()
            } else {
                this.$emit('loadAppointments')
            }
            this.$emit('closePaymentModal')
        },
        goRoot () {
            this.$router.push('/patient')
        },
        checkPromotionCode () {
            // TODO: Not finished. Fill in when necessary comparing with 'checkPromotionCode' in paytpv-template.js
            if (!this.promotionCode) {
                this.$store.dispatch('showInfoAlert', this.$t('payments.mustInsertCode'))
                return
            }
            promotionCodesRepository.getCodeDiscount(this.promotionCodeData).then((result) => {
                let data = result.data.data
                if (!data) {
                    this.$store.dispatch('showDangerAlert', this.$t('payments.invalidCode'))
                } else {
                    this.isFixedPriceDiscount = data.isFixedPriceDiscount
                    this.discountApplied = data.discount
                    this.$store.dispatch('showInfoAlert', this.$t('payments.appliedDiscount', {discount: this.discountApplied, symbol: this.isFixedPriceDiscount ? this.currency : PERCENT_SYMBOL}))
                    if (this.freeService) {
                        this.paymentMethodSelected = null
                    }
                }
            })
        },
        applyFullDiscount () {
            if (this.appointmentData) {
                this.onFreeAppointmentOrBizumDirect()
            } else {
                promotionCodesRepository.applyDiscount(this.promotionCodeData).then((result) => {
                    let data = result.data.data
                    if (!data) {
                        this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                    } else {
                        this.closeModalAndReload()
                    }
                })
            }
        },
        onFreeAppointmentOrBizumDirect () {
            this.$emit('onFreeAppointmentOrBizumDirect', { promotionCode: this.promotionCode, bizumDirectPhone: this.paymentInfo.bizumPhone })
        },
        cvvChange () {
            this.cvvInputType = this.creditCardData.cvv ? 'password' : 'text'
        }
    },
    watch: {
        'creditCardData.cardNumber' () {
            this.creditCardData.cardNumber = this.creditCardData.cardNumber ? this.creditCardData.cardNumber.replace(/ /gi, '').match(/.{1,4}/g).join(' ') : null
            this.creditCardData.sanitizedCardNumber = this.creditCardData.cardNumber.trim().replace(/\s/g, '')
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/payments.mixin.js